import { action } from 'typesafe-actions';
import { DepositanteTypes, IDepositante } from './types';

export const loadRequest = (codCdd:number, parceiros:number[]) => action(DepositanteTypes.LOAD_REQUEST,{codCdd, parceiros});
export const loadSuccess = (data: IDepositante[]) => action(DepositanteTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(DepositanteTypes.LOAD_FAILURE);
